export type StatTileProps = {
  label: string;
  value: number | string;
  className?: string;
  onClick?: () => void;
};

export default function StatTile({
  label,
  value,
  className = "",
  onClick,
}: StatTileProps) {
  return (
    <div
      className={`rounded-lg border border-slate-700/50 bg-black/30 p-4 ${onClick ? "cursor-pointer hover:bg-white/5 transition-colors" : ""} ${className}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="text-xs text-slate-400">{label}</div>
      <div className="text-2xl font-bold text-white mt-1">{value}</div>
    </div>
  );
}

